import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { governorates } from '../redux/data/governorates'
import { cities } from '../redux/data/city'
import avatar from '../public/images/avatar5.png'

import Pay from '../Components/Pay'
import { useDispatch, useSelector } from 'react-redux'
import axios from 'axios'
import { URL } from '../config'
import { useForm } from 'react-hook-form'
import Order from '../redux/hooks/Order'
import { setErrorMessage, setSuccessMessage } from '../redux/slices/MessageSlice'
import PaymentDetails from '../Components/PaymentDetails'

const Payment = (props) => {
     const dispatch=useDispatch(); 
     const navigate = useNavigate();
     const [governorate,setGovernorate]=useState(governorates[0]);
     const [governorateCities,setGovernorateCities]=useState([]);
     const {currentUser,token}=useSelector((state)=>state.AuthReducer);
     const {code}=useSelector((state)=>state.CodeReducer);     
     const [select,setSelect]=useState(0);
     const location = useLocation();
     const {makeRequestOrder, data, isLoading, error,success}=Order();
     useEffect(()=>{
      if(success){
        dispatch(setSuccessMessage('تم ارسال الطلب'))
        navigate('/orders')
       }
     },[success])
     useEffect(()=>{
      if(error){
        // dispatch(setErrorMessage(error.))

              dispatch(setErrorMessage(error.response.data.message))
           
       }
     },[error])
     
     console.log(location.state);
   
     const HandelSelect=(id)=>{
       setSelect(id)
     }
    
          const { handleSubmit, register, formState, reset } =useForm();

          const governorateHandle=(event)=>{
            const gov=governorates.find((e)=>e.id===event.target.value)            
            setGovernorate(gov);
            console.log('govdsadasdas',event.target.value);
            }
          const { errors } = formState;
          const onSubmit = (data) => {
            makeRequestOrder(
              {
                ...data,
                billing_total:location.state.cart_total,
                payment_method:'cash_on_delivery',
                products:location.state.items,
                code:code
              }
            ) 
        };
        
   
  useEffect(()=>{
    document.body.style.backgroundColor='#d4d4d442'
  },[])
  useEffect(()=>{
     const selectedCity=cities.filter((city)=>city.governorate_id===governorate.id)
     setGovernorateCities(selectedCity);
     reset({governorate:governorate.governorate_name_ar,city:selectedCity[0].city_name_ar})
   },[governorate])
  return (
     <div className='container'>
{/* <table class="table table-bordered fixed-top" style={{zIndex:1,textAlign:'center' }}>
  <thead>
  <tr className='pay-table-th'>
       <th>ملخص السلة</th>
       <th >تكلفة الشحن</th>
       <th>اجمالي الطلب</th>
    </tr>
  </thead>
  <tbody>
    <tr className='table-bordered'>
      <td>{location.state.cart_total} <span>ج.م</span></td>
      <td>مجاناً</td>
      <td>{location.state.cart_total} <span>ج.م</span></td>
    </tr>
  </tbody>
</table> */}
<div className='mt-5 '>
  
  <div className='payment'>
        <div className='d-flex align-items-center section'>
        {/* <Link to='/' style={{textDecoration:'none',backgroundColor:'black',padding:'10px',borderRadius:'5px'  }}><h2  className="logo">تاج</h2></Link>  */}
         <img src={currentUser&&currentUser.image?currentUser.image:avatar} alt='user image' style={{ borderRadius:'100%',width:'100px',height:'100px' }}/>
        
        <div className='d-flex flex-column gap-1'>
        <p style={{ fontSize:'20px',marginBottom:0, marginRight:'10px',padding:'10px 10px 10px 0',borderRight:'4px solid #f9f9f9' }}>مرحباً , {currentUser?.f_name?currentUser.f_name:currentUser?.email.slice(0, currentUser.email.indexOf('@')).slice(0,12)}</p>
        <p style={{ fontSize:'14px',marginRight:'14px',padding:'0px 10px 10px 0'  }}>إتمام الدفع
        </p>
           
        </div>
        </div>
        <PaymentDetails price={location.state.cart_total} city={governorate}/>
        <div className='section'>
          <div className='d-flex carry align-items-center'>
          <div className='carry-number'><i class="fa-solid fa-1"></i></div>
          <p>الشحن والتوصيل</p>
          </div>
          <div class="alert alert-primary " role="alert">
          الشحن داخل جمهورية مصر العربية !
          </div>
          <p>عنوان الشحن</p>
          {/* <button className='select-location'>
          <i class="fa-solid fa-location-crosshairs"></i>
          حدد عنوانك من الخريطة
          </button> */}
          <form className='mt-4' onSubmit={handleSubmit(onSubmit)} >
          <div className='row'>
    
            <div className='col-md-6 d-flex flex-column'>
                 <label className='mb-2' for="governorate">اختر المحافظة</label>
                 <select type='text'
                // value={governorate}
                  // {...register("governorate",{
                  //   required: "المحافظة مطلوب",
                  // })} 
                 onChange={(e)=>governorateHandle(e)}
                 id="governorate" 
                  className='city'>
                   {governorates.map((govern)=>(
                  <option value={govern.id} selected={govern.id===governorate.id}>{govern.governorate_name_ar}</option>
                   ))}
                 </select>
                 {errors.governorate&&<div className='text-danger'>{errors.governorate.message}</div>}

            </div>
            <div className='col-md-6 d-flex flex-column'>
                 <label className='mb-2' for="city">اختر المدينة</label>
                 <select  id="city" 
                  {...register("city",{
                    required: "المدينة مطلوب",
                  })} 
                  className='city'  >
                 {governorateCities.map((city)=>(
                  <option value={city.city_name_ar}>{city.city_name_ar}</option>
                   ))}
                 </select>
                 {errors.city&&<div className='text-danger'>{errors.city.message}</div>}

            </div>
            <div className='col-md-6 d-flex flex-column mt-3'>
                 <label className='mb-2' for="quarter">الحى</label>
                 <input type='text' 
                 {...register("quarter",{
                  required: "المدينة مطلوب",
                })} 
                  id="quarter"  className='city' />
                {errors.quarter&&<div className='text-danger'>{errors.quarter.message}</div>}

            </div>
            <div className='col-md-6 d-flex flex-column mt-3'>
                 <label className='mb-2' for="street">الشارع</label>
                 <input type='text' 
                  {...register("street",{
                    required: "المدينة مطلوب",
                  })}  
                 id="street"  className='city' />
                 {errors.street&&<div className='text-danger'>{errors.street.message}</div>}

            </div>
            <div className='col-md-6 d-flex flex-column mt-3'>
                 <label className='mb-2' for="house" > وصف البيت  (اختيارى)  </label>
                 <input type='text'
                  {...register("house")} 
                 id="house"  className='city' />
                 {errors.house&&<div className='text-danger'>{errors.house.message}</div>}

            </div>
            <div className='col-md-6 d-flex flex-column mt-3'>
                 <label className='mb-2' for="phone">رقم التلفون </label>
                 <input type='text' 
                  {...register("phone",{
                    required: "رقم التلفون مطلوب",
                    pattern: {
                      value: /^(?:\d{2}-\d{3}-\d{3}-\d{3}|\d{11})$/,
                      message: 'رقم التلفون غير صحيح'
                    }
                  })} 
                 id="phone"  className='city' />
                 {errors.phone&&<div className='text-danger'>{errors.phone.message}</div>}
            </div>
          </div>
          <Pay select={select} HandelSelect={HandelSelect}/>

        {isLoading?(
          <button className='pay-button d-flex gap-2 align-items-center justify-content-center' disabled style={{backgroundColor:''}} 
           >Loading
           <div class="spinner-border spinner-border-sm"  role="status">
            <span class="visually-hidden" >Loading...</span>
          </div>
           </button>
        )
        :select===1?(
        <button className='pay-button'>اكمال الدفع</button>
        ):(
         <button className='pay-button' type='submit' style={{backgroundColor:''}} 
        //  onClick={completePay}
         >اكمال الطلب</button>
        )}
          </form>
        </div>
       
        

  </div>
  </div>
     </div>
   
  )
}

export default Payment